$(document).ready(function() {
    console.log("A11y start");

    $('.main-content .product-page .product__main__content .product__block__text h6').attr({
        role: "heading",
        "aria-level": "2"
    })

    $('.vip-box h4:first').attr({
        role: 'heading',
        'aria-level': '3'
    });

    $('.standard__heading.heading-size-8').attr({
        role: 'heading',
        'aria-level': '2'
    });

    $('#shopify-section-template--19852638421221__section_richtext_z4hwhP .text__standard .standard__heading').attr({
        role: 'heading',
        'aria-level': '1'
    });

    $('#shopify-section-template--19852638290149__section_richtext_Drarrf .standard__heading').attr({
        role: 'heading',
        'aria-level': '1'
    });

    $('.wrapper.section-padding .text__standard .standard__heading.heading-size-10:first').attr({
        role: 'heading',
        'aria-level': '2'
    });

    $('#accessibility-statement h2.standard__heading').attr({'role': 'heading', 'aria-level': '1'});
    $('#accessibility-statement #main-content h1:first').attr({'role': 'heading', 'aria-level': '2'});
    $('#deyhydrated-irritated-amp-sensitized-skin section div.standard__heading.heading-size-8').attr({
      'role': 'heading', 'aria-level': '2'
    });

    $('input[name="contact[full-name]"]').attr({'autocomplete': 'name'});
    $('input[name="contact[email]"]').attr({'autocomplete': 'email'});

    $('input[name="customer[first_name]"]').attr({'autocomplete': 'given-name'});
    $('input[name="customer[last_name]"]').attr({'autocomplete': 'family-name'});
    
    $('.footer__block.footer__block--socials h3').attr({'role': 'heading', 'aria-level': '2'});
    
    $('.tulip-growth-section img[src*="BFX_TulipBulb_white.png"]').attr('alt', 'Our Tulip Bulb moment');

    $('.tab__scroll .tabs').attr('role', 'tablist');
    $('.tab__scroll .tabs button').attr('role', 'tab');

    $('main#main-content').attr('role', 'presentation');
    $('#customer_login div.errors').removeAttr('tabindex');

    $('.bundles-product .product-cell').each(function() {
        var productName = $(this).find('.product-content h3').text().trim();
        var buttonText  = $(this).find('button.btn').text().trim();
        
        $(this).find('button.btn').attr(
            'aria-label',
            buttonText + ', ' + productName
        );
    });


    (function () {
      function stripDotRoles() {
        $('.slick-dots[role]').removeAttr('role');
        $('.slick-dots button[role]').removeAttr('role');
      }

      stripDotRoles();

      const obs = new MutationObserver((mutations) => {
        let touched = false;

        for (const m of mutations) {
          if (m.type === 'childList') {
            for (const n of m.addedNodes) {
              if (
                n.nodeType === 1 &&
                (n.matches('.slick-dots') || n.querySelector?.('.slick-dots'))
              ) {
                touched = true;
                break;
              }
            }
          } else if (
            m.type === 'attributes' &&
            m.attributeName === 'role' &&
            m.target.matches('.slick-dots, .slick-dots button')
          ) {
            touched = true;
            break;
          }
        }

        if (touched) stripDotRoles();
      });

      obs.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        // attributeFilter: ['role']
      });
    })();
    
    setTimeout(function() {
      // $("#shopify-section-template--19852637765861__main article.grid__item.medium-up--two-thirds img").attr('alt', '');
      $("#shopify-section-template--19852638683365__section_custom_content_zfXBx3 .image__hero__frame .image__hero__pane img").attr('alt', '');
      $('#shopify-section-template--19852638224613__icons .icon__column__icon img, #shopify-section-template--19852638748901__section_icons_PMDfh3 img').attr('alt', "");
      $('#rebuy-widget-228092 .rebuy-bundle-builder__group-container-body-items').attr('tabindex', '0');

      $("<div>", {
			id: "sr-announcer",
			"aria-live": "polite",
			style:
			  "position:absolute; left:-9999px; height:1px; width:1px; overflow:hidden;",
		  }).appendTo("body");
		  function announce(message) {
        const $announcer = $("#sr-announcer");
        $announcer.text("");
        setTimeout(() => {
          $announcer.text(message);
        }, 50);
        setTimeout(() => {
          $announcer.text("");
        }, 2000);
		  }
		  function bindAnnounce(selector, message) {
          $(selector).on("click keydown", function (e) {
            if (
            e.type === "click" ||
            (e.type === "keydown" &&
              (e.key === "Enter" || e.key === " " || e.key === "Spacebar"))
            ) {
            announce(message);
            console.log("Button hit");
          }
        });
      }
      bindAnnounce(".slick-prev.slick-arrow", "Slide Changed");
      bindAnnounce(".slick-next.slick-arrow", "Slide Changed");
      bindAnnounce("button.pswp__button.pswp__button--arrow--left", "Slide Changed");
      bindAnnounce("button.pswp__button.pswp__button--arrow--right", "Slide Changed");
      bindAnnounce(".wrapper.section-padding button", "Loading");
      bindAnnounce("button.btn--add-to-cart", "Loading");
      // bindAnnounce("#create_customer button.btn--outline.btn--full", "Loading");
      
      
      $('.stockist-result-image img[src*="blue-mercury.jpg"]').attr('alt', 'Bluemercury® makeup skincare spa');
      $('.has-progress .rebuy-bundle-builder__progress-bar-meter-fill').attr('aria-label', 'fill');
      $('.has-progress .rebuy-bundle-builder__progress-bar-meter-fill').removeAttr('aria-labelledby');

      $('.rebuy-bundle-builder__step-container').removeAttr('role');
      $('.rebuy-bundle-builder__step-container').removeAttr('aria-label');
      $('.rebuy-bundle-builder__step-body.rebuy-product-grid').attr('role', 'list');
      $('#deyhydrated-irritated-amp-sensitized-skin .image__hero__frame img').attr('alt', "");
      $('.okeReviews-reviews-review article.okeReviews-review').attr('role', 'presentation');
      $('a.leaflet-popup-close-button').attr('role', 'button');

      $('.rebuy-bundle-builder__group-container-body-items .rebuy-bundle-builder__product-holder').each(function () {
        var $holder = $(this);
        var $heading = $holder.find('h3.rebuy-product-title');
        var productName = $heading.text().trim();

        $holder.find('.rebuy-bundle-builder__product-holder-info-delete').attr('aria-label', 'Remove ' + productName);
        $heading.attr('role', 'presentation');
      });

      $('.stockist-search-form .stockist-query-entry').each(function () {
        var $entry = $(this);
        var $input = $entry.find('input[type="text"]');
        var inputId = $input.attr('id');

        if (inputId) {
          if ($entry.prev('label[for="' + inputId + '"]').length === 0) {
            $('<label>', {
              for: inputId,
              text: 'Search for a store'
            }).insertBefore($entry);
          }
        }
        $input.removeAttr('aria-label');
      });

      $('.rebuy-cart__flyout ul[data-smartcart-items]').removeAttr('role');
      $('.rebuy-cart__flyout ul[data-smartcart-items] li').removeAttr('aria-label');
      $("bloop-social-contain bloop-social-item").attr({
        "tabindex": "0",
        "role": "button"
      });

      $('#rebuy-widget-228092 h2:first').attr({'role': 'heading', 'aria-level': '1'});
      $('#rebuy-widget-228092 h3.rebuy-bundle-builder__step-header-title:first').attr({'role': 'heading', 'aria-level': '2'});
      $('.rebuy-bundle-builder__step-container .rebuy-product-info a').removeAttr('role');
      $('.rebuy-bundle-builder__step-container .rebuy-product-info a').removeAttr('aria-level');

      setTimeout(() => {
        $(".rebuy-product-info .rebuy-money span").removeAttr("tabindex");
        $(".rebuy-widget h4.primary-title").attr({"role":"heading", "aria-level":"3"});
      }, 2000);

      $('.rebuy-bundle-builder__step-product .rebuy-product-info .rebuy-product-title.clickable').each(function () {
        $(this).wrap('<div role="heading" aria-level="3"></div>');
      });

      $(".cusstom-content h2, .bss__bloop--guide-header .bloop_h1, .bss__bloop--reward-header .bloop_h1, #shopify-section-template--19852638355685__section_columns_xwdQtJ .accent-title-large").attr({
        role: "heading",
        "aria-level": "2"
      });
      $(".bloop__referral--header .bloop_h1").attr({
        role: "heading",
        "aria-level": "1"
      });
      $(".bss__bloop--guide-item .bss__bloop--item-header").attr({
        role: "heading",
        "aria-level": "3"
      });
      $(".rebuy-cart__progress-bar-meter .rebuy-cart__progress-bar-meter-fill").removeAttr("tabindex");

    }, 5000);

    $('bloop-block-form input[name="customer[email]"]').each(function() {
      var label = $('<label class="email_label" for="customer-email">Email</label>');
      $(this).attr('id', 'customer-email');
      $(this).before(label);
    });


    $(".tulip-section h2").attr("role", "none");

    $('.tulip-section h1:first').each(function() {
    const $h1 = $(this);
    const visualHTML = $h1.html();
    const visualText = $h1.text().trim();

    $h1.attr("aria-hidden", "true");
    $h1.after(`<h2 class="visually-hidden">${visualText}</h2>`);
});

    $(".okeReviews-review-reviewer-profile-status").each(function () {
      const $el = $(this);
      const label = $el.attr("aria-label") || $.trim($el.text());

      $el.attr("aria-hidden", "true");
      $('<span class="visually-hidden">' + label + '</span>').insertAfter($el);
    });

    $('leaflet-popup-close-button').attr('role', 'button');

    $('.sidebar__heading.js').removeAttr('aria-haspopup');
    $('.sidebar__heading.js.accordion-is-open').attr('aria-expanded', 'true');
    $('button.sidebar__heading.js').on('click', function () {
      const current = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !current);
    });

    $('.index__column.grid__item.slide-item').each(function () {
      var $title = $(this).find('.accent-title-large').text().trim();
      var $link = $(this).find('a.btn--neutral.btn-text-thick-line');

      if ($title && $link.length) {
        var linkText = $link.text().replace(/→/g, '').trim();
        $link.attr('aria-label', linkText + ' about ' + $title);
      }
    });

    $('.article__item').each(function () {
      var $item = $(this);
      var titleText = $item.find('.article__item-title').text().trim();
      var link = $item.find('a.text-link-bare');
      var linkText = link.text().trim();

      if (titleText && link.length) {
        link.attr('aria-label', linkText + ' about ' + titleText);
      }
    });

    $('.sidebar__item.sidebar__item--active.stateful-filter-icons a').attr('aria-current', 'true');

    $('body').keydown(function (event) {
      if (event.key == 'Escape') {
        document.body.classList.add('prevent-tooltips');
      }
    })
    $('body').mousemove(function (event) {
      document.body.classList.remove('prevent-tooltips');
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        $('.header__dropdown').removeClass('is-visible');
      }
    });

    $('.bloop__referral--code input').attr('aria-label', 'Copy referral link');

    // $('.metafield-rich_text_field').each(function () {
    //   var $wrapper = $(this);
    //   var $paragraphs = $wrapper.find('p');

    //   if ($paragraphs.length > 1) {
    //     $wrapper.attr('role', 'list');
    //     $paragraphs.attr('role', 'listitem');
    //   }
    // });

    $('h4#vip-title:first, .product__block__text h5:first').attr({'role': 'heading', 'aria-level': '2'});

    $(".media__thumb__holder .media__thumb__wrapper .media__thumb, .flickity-slider .okeReviews-mediaGalleryReviewDialog-nav-slide").on("keydown", function(e) {
      if (e.key === "Enter" || e.which === 13) {
        $(this).trigger("click");
      }
    });

    $("bloop-social-contain bloop-social-item").on("keydown", function(e) {
      if (e.key === "Enter" || e.which === 13) {
        $(this).trigger("click");
      }
    });

    setInterval(function() {
      $("#create_customer .errors").removeAttr("tabindex");
    }, 50);

    // $(".js-grid .product-grid-item").each(function() {
    //   let $item = $(this);

    //   let collText = $item.find(".htusb-ui-coll-text_msg").first().text().trim();
    //   let badgeText = $item.find(".product__badge").first().text().trim();
    //   let titleEl = $item.find(".product__grid__info.text-left a:first .product__grid__title");
    //   let titleText = titleEl.text().trim();

    //   let srParts = [titleText];
    //   if (badgeText) srParts.push(badgeText);
    //   if (collText) srParts.push(collText);

    //   let srText = srParts.join(" - ");

    //   if (titleEl.prev(".sr-only").length === 0) {
    //     $("<div class='sr-only'>" + srText + "</div>").insertBefore(titleEl);
    //   }

    //   titleEl.attr("aria-hidden", "true");
    // });


    var $firstH2 = $("#accessibility-statement main h2:first");

  if ($firstH2.length) {
    var $h1 = $("<h1>", {
      html: $firstH2.html()
    });

    $.each($firstH2[0].attributes, function (_, attr) {
      $h1.attr(attr.name, attr.value);
    });

    $firstH2.replaceWith($h1);
  }

$("#shopify-section-template--19852639142117__image_custom_html_kTzJhQ .image-box img").attr({
  'data-gif': '//bloomeffects.com/cdn/shop/files/INGREDIENTS-45-gif.gif',
  'data-still': '//bloomeffects.com/cdn/shop/files/water_plant.png',
  'data-state': 'playing'
});

$("#shopify-section-template--19852639142117__image_custom_html_kTzJhQ .image-box").append(`
  <button id="toggleBtn" aria-label="Pause Gif" class="toggleBtn">
    <span id="btnIcon">❚❚</span>
  </button>
`);

let gifImg = $(".column__image .relative img[src*='INGREDIENTS-45-gif.gif']");

gifImg.attr({
  'data-gif': '//bloomeffects.com/cdn/shop/files/INGREDIENTS-45-gif.gif',
  'data-still': '//bloomeffects.com/cdn/shop/files/water_plant.png',
  'data-gif-id': 'Tulip-growth',
  'data-state': 'playing'
});

let relativeBox = gifImg.closest(".relative");

relativeBox.append(`
  <button id="toggleBtn_2" class="toggleBtn" aria-label="Pause Gif">
    <span id="btnIcon">❚❚</span>
  </button>
`);

$("#toggleBtn_2").on("click", function () {
  const $image = $(".column__image .relative img[data-gif-id='Tulip-growth']");
  const $this = $(this);

  if ($image.data("state") === "playing") {
    $image.attr("src", $image.data("still"));
    $image.attr("srcset", $image.data("still"));
    $image.data("state", "paused");
    $("#btnIcon").text("▶");
    $this.attr("aria-label", "Play Gif");
  } else {
    const gifUrl = $image.data("gif") + "?t=" + new Date().getTime();
    $image.attr("src", gifUrl);
    $image.attr("srcset", gifUrl);
    $image.data("state", "playing");
    $("#btnIcon").text("❚❚");
    $this.attr("aria-label", "Pause Gif");
  }
});

$("#toggleBtn").on("click", function () {
  const $image = $("#shopify-section-template--19852639142117__image_custom_html_kTzJhQ .image-box img");
  const $this = $(this);

  if ($image.data("state") === "playing") {
    $image.attr("src", $image.data("still"));
    $image.attr("srcset", $image.data("still"));
    $image.data("state", "paused");
    $("#btnIcon").text("▶");
    $this.attr("aria-label", "Play Gif");
  } else {
    const gifUrl = $image.data("gif") + "?t=" + new Date().getTime();
    $image.attr("src", gifUrl);
    $image.attr("srcset", gifUrl);
    $image.data("state", "playing");
    $("#btnIcon").text("❚❚");
    $this.attr("aria-label", "Pause Gif");
  }
});

    console.log("A11y end");
});
